import { render, staticRenderFns } from "./ThgDescriptionSvgRegistration.vue?vue&type=template&id=07846123"
import script from "./ThgDescriptionSvgRegistration.vue?vue&type=script&lang=ts"
export * from "./ThgDescriptionSvgRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports